import {GET_TERMS_PAGE, GET_TERMS_PAGE_SUCCEEDED, GET_CONFIDENTIALITY_PAGE, GET_CONFIDENTIALITY_PAGE_SUCCEEDED, CONTACT_PAGE, CONTACT_PAGE_SUCCEEDED} from "./types";

export const getTermsPage = (payload) => ({
    type: GET_TERMS_PAGE,
    payload,
});

export const getTermsPageSucceded = (payload) => ({
    type: GET_TERMS_PAGE_SUCCEEDED,
    payload,
});

export const getConfidentialityPage = (payload) => ({
    type: GET_CONFIDENTIALITY_PAGE,
    payload,
});

export const getConfidentialityPageSucceded = (payload) => ({
    type: GET_CONFIDENTIALITY_PAGE_SUCCEEDED,
    payload,
});

export const contactPage = (payload) => ({
    type: CONTACT_PAGE,
    payload
})

export const contactPageSucceeded = (payload) => ({
    type: CONTACT_PAGE_SUCCEEDED,
    payload
})



// WEBPACK FOOTER //
// ./src/SHARED/actions/pages.actions.js